import { h } from './index-d3a9c8bd.js';
import { c as clsx } from './clsx-1afe6a70.js';
import { A as ARIA } from './constants-93a27459.js';
import { g as getLanguage } from './locale.utils-0b3b3ff2.js';

const INTERNAL_NES_ERROR_MESSAGE_TRANSLATIONS = {
    nl: {
        generalErrorMessage: 'Er is een fout opgetreden.',
    },
    en: {
        generalErrorMessage: 'An error has occurred.',
    },
};

const InternalNesErrorMessage = ({ nesId, error, element }) => (h("nes-error-message", { id: nesId ? nesId + ARIA.error : '', class: clsx({
        'nes-error-message-sr-only': ['true', 'false'].includes(String(error)) ||
            !(error !== undefined && error !== ''),
    }) }, ['true', 'false'].includes(String(error)) ||
    !(error !== undefined && error !== '')
    ? INTERNAL_NES_ERROR_MESSAGE_TRANSLATIONS[getLanguage(element)]
        .generalErrorMessage
    : error));

const getErrorMessage = (error, nesId, element) => {
    if (isError(error)) {
        return h(InternalNesErrorMessage, { nesId, error, element });
    }
};
const isError = (error) => {
    return error !== undefined && !(error === 'false' || error === false);
};

export { getErrorMessage as g, isError as i };
